import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/performance-guarantees" });

export const PerformanceGuaranteesService = {
  createPerformanceGuarantee: (pgDetails) => {
    return api.post("/", pgDetails);
  },

  getPerformanceGuarantees: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/?${params.toString()}`);
  },

  getPerformanceGuaranteeById: (pgId) => {
    return api.get(`/${pgId}`);
  },

  addReturn: (pgId, returnDetails) => {
    return api.patch(`/${pgId}/release`, returnDetails);
  },

  updatePerformanceGuarantee: (pgId, pgDetails) => {
    return api.patch(`/${pgId}`, pgDetails);
  },

  deletePerformanceGuarantee: (pgId) => {
    return api.delete(`/${pgId}`);
  },
};
